export enum EntityAccessType {
	Scenario = 'a_b',
	Agent = 'agent',
	Chat = 'chat',
	Context = 'context',
	ContextFolderAging = 'context_folder_a',
	ContextFolderFinance = 'context_folder_f',
	ContextFolderItems = 'context_folder_i',
	Custom = 'custom',
	CustomResource = 'custom_resource',
	FinanceDim = 'fin_dim',
	AgingDim = 'inv_dim',
	ItemsDim = 'itm_dim',
	ItemAmount = 'itm_amount',
	ItemAmountBalance = 'itm_amount_balance',
	ItemIndicator = 'itm_indicator',
	ItemQty = 'itm_qty',
	ItemQtyBalance = 'itm_qty_balance',
	Job = 'job',
	MdTable = 'md_table',
	Statement = 'statement',
	StatementRow = 'statement_row',
	Thread = 'thread',
}

export const DEFAULT_ENTITY_ACCESS_CHANGE: Record<EntityAccessType, boolean> = {
	[EntityAccessType.Scenario]: true,
	[EntityAccessType.Agent]: true,
	[EntityAccessType.Chat]: true,
	[EntityAccessType.Context]: true,
	[EntityAccessType.ContextFolderAging]: true,
	[EntityAccessType.ContextFolderFinance]: true,
	[EntityAccessType.ContextFolderItems]: true,
	[EntityAccessType.Custom]: true,
	[EntityAccessType.CustomResource]: true,
	[EntityAccessType.FinanceDim]: false,
	[EntityAccessType.AgingDim]: false,
	[EntityAccessType.ItemsDim]: false,
	[EntityAccessType.ItemAmount]: false,
	[EntityAccessType.ItemAmountBalance]: false,
	[EntityAccessType.ItemIndicator]: false,
	[EntityAccessType.ItemQty]: false,
	[EntityAccessType.ItemQtyBalance]: false,
	[EntityAccessType.Job]: true,
	[EntityAccessType.MdTable]: true,
	[EntityAccessType.Statement]: true,
	[EntityAccessType.StatementRow]: true,
	[EntityAccessType.Thread]: true,
};


export type AccessRight = {
	accounting?: number;
	id_accounting_group?: number;
	right?: string;
	id_access_role?: number;
	role?: string;
	user_name?: string;
	login_name?: string;
	company?: string;
	group_name?: string;
	source?: string;
	id_source?: number;
	source_name?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type AccessRole = {
	id_access_role?: number;
	role?: string;
	id_accounting_group?: number;
	user_name?: string;
	description?: string;
	email?: string;
	users?: string;
	display_users?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type EntityAccess = {
	accounting?: number;
	user_name?: string;
	id_access_role?: number;
	id?: string;
	entity?: string;
	allow?: boolean;
	login_name?: string;
	role?: string;
	name?: string;
	level?: number;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type ScimGroup = {
	id_origin?: string;
	meta_created?: string;
	meta_modified?: string;
	total?: number;
	id_access_role?: number;
	role?: string;
	id_accounting_group?: number;
	user_name?: string;
	description?: string;
	email?: string;
	users?: string;
	display_users?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type ScimUser = {
	origin?: string;
	id_origin?: string;
	meta_created?: string;
	meta_modified?: string;
	total?: number;
	user_name?: string;
	login_name?: string;
	password_hash?: string;
	last_accounting?: number;
	rights?: string;
	tfa_secret?: string;
	tfa_method?: number;
	lang?: string;
	password_change_token?: string;
	id_accounting_group?: number;
	password?: string;
	login_name_2?: string;
	email?: string;
	phone?: string;
	last_login?: string;
	disabled?: boolean;
	user_groups?: string;
	display_user_groups?: string;
	accounting_groups?: string;
	display_accounting_groups?: string;
	domain_login_name?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type Timesheet = {
	idz?: number;
	user_name?: string;
	login_name?: string;
	accounting?: number;
	company?: string;
	id_accounting_group?: number;
	group_name?: string;
	service?: string;
	date_start?: string;
	date_end?: string;
	seconds?: number;
}

export type TimesheetDay = {
	date?: string;
	user_name?: string;
	login_name?: string;
	accounting?: number;
	company?: string;
	id_accounting_group?: number;
	group_name?: string;
	date_start?: string;
	date_end?: string;
	seconds?: number;
	segments?: number;
}

export type UserEntityAccess = {
	id?: string;
	entity?: string;
	allow?: boolean;
	inherited?: boolean;
	shared?: boolean;
	accounting?: number;
}